module.exports = __webpack_public_path__ + "static/media/Niveau_elN12_2_85662.63423716.png";